<!-- [ngStyle]="{ 'margin-right': isOpenAsideMap ? 'calc(460px + 1rem)' : '1rem' }" -->
<div
  class="carousel-container d-flex justify-content-between align-items-center"
  [class.invisible]="!display"
  [class.hidden]="qtyItems === 0"
>
  <button
    (click)="scrollCarousel(-248)"
    pButton
    pRipple
    type="button"
    icon="pi pi-chevron-left"
    class="p-button-rounded p-button-secondary p-button-text button-left"
    id="button-left"
  ></button>
  <div
    class="scroll-section"
    #carouselSection
    id="scroll-section"
    (scroll)="onScroll()"
  >
    <div class="carousel-wrapper" #carouselWrapper>
      <!-- Cambiamos ng-container por ng-template -->
      <ng-template #dynamicComponentsContainer></ng-template>
    </div>
  </div>
  <button
    (click)="scrollCarousel(248)"
    pButton
    pRipple
    type="button"
    icon="pi pi-chevron-right"
    class="p-button-rounded p-button-secondary p-button-text button-right"
    id="button-right"
  ></button>
</div>
